import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Opened from a broadcast's «Оформить подписку» button (?bc=<token>): count the click (2026-10-20)
try {
  const bcToken = new URLSearchParams(window.location.search).get('bc')
  if (bcToken && /^[A-Za-z0-9_-]{8,24}$/.test(bcToken)) {
    fetch(`${import.meta.env.VITE_API_URL || '/api/v1'}/go/${bcToken}?open=1`).catch(() => {})
  }
} catch {
  // never block the app start
}
